import Footer from "@/components/navigation/Footer";
import NavBar from "@/components/navigation/NavBar";
import React from "react";
import { useParams } from "react-router-dom";
import ContactOptionsTabs from "@/components/calltoaction/CtaContact";
import GoogleTestimonials from "@/components/Landingpage/GoogleRating";
import {
  IconCircleCheck,

} from "@tabler/icons-react";
import StepsVerkaufen from "@/components/design/StepsVerkaufen";
import CtaBewertenPoll from "@/components/calltoaction/CtaPdfBewerten";
import VorteileSection from "@/components/design/VorteileSection";
import Proof from "@/components/proofs/Proof";
import FirstStepForm from "./FirstStepBewertenForm";
import FaqSection from "@/components/navigation/faq";

export default function FormLandingpage() {
  const { type } = useParams();

  const formTitles = {
    immobilie: "Immobilienbewertung",
    haus: "Hausbewertung",
    wohnung: "Wohnungsbewertung",
    mehrfamilienhaus: "Mehrfamilienhausbewertung",
  };

  const formTitle = formTitles[type] || "Bewertung";
  return (
    <div className=" bg-prime-50/50 from-prime-100 from-5% via-10% to-100% via-prime-50 to-white">
      <NavBar className=" bg-white/100" />
      <div className=" pt-16 mx-auto">
        <div className=" mx-auto bg-prime-900 py-10 pb-0 px-4 sm:px-6 lg:px-8">
          <div className="max-w-[85rem] mx-auto  sm:px-6 lg:px-8 pb-10 md:py-10">
              <FirstStepForm />
              <div className="pt-10 flex md:flex-row flex-col md:items-center space-y-3 md:space-y-0 items-start justify-center ">
                <div className="flex items-center gap-1 mr-5">
                  <IconCircleCheck className="text-prime-500 size-5" />{" "}
                  <p className="text-prime-50">Kostenlos & unverbindlich</p>
                </div>
                <div className="flex items-center gap-1 mr-5">
                  <IconCircleCheck className="text-prime-500 size-5" />{" "}
                  <p className="text-prime-50">
                    Vom regionalen Experten ermittelt
                  </p>
                </div>
                <div className="flex items-center gap-1 ">
                  <IconCircleCheck className="text-prime-500 size-5" />{" "}
                  <p className="text-prime-50">
                    Schnell zum optimalen Verkaufspreis
                  </p>
                </div>
              </div>
              <div className="max-w-[40rem] mx-auto gap-2 mt-10">
              <Proof text="gray-200" className="md:justify-center gap-7" />
              </div>
          </div>
        </div>
        <div className="">
          <VorteileSection />
        </div>
        <hr className="border-gray-300 max-w-[85rem] mx-auto" />
        <div className="mx-auto max-w-[85rem] py-10 pt-20 px-4 sm:px-6 lg:px-8 overflow-hidden">
          <h2 className="font-serif text-prime-950 font-medium md:text-4xl text-2xl leading-10 pb-10 md:pb-20 ">
              In drei Schritten zur fundierten Immobilienbewertung
            </h2>
          <StepsVerkaufen />
        </div>
        <div className="bg-white max-w-[85rem] mx-auto my-10 md:my-20 md:mt-40">
          <CtaBewertenPoll />
        </div>
        <div>
          <GoogleTestimonials />
        </div>
        <div className="py-20 bg-white  ">
          <ContactOptionsTabs />
        </div>
      </div>
      <div>
        <FaqSection faqArt="bewerten" />
      </div>

      <Footer />
    </div>
  );
}
